import React from 'react';
import data from '../products.json';
import NotFound from './NotFound';
import { generateFullTitle, getProductTitle, getProductContent } from '../helpers';
import { Image } from './Image';
import { useTranslation } from 'react-i18next';
import SEO from './SEO';

const search = (props) => {
    if (!props.match || !props.match.params || !props.match.params.id) {
        return null;
    }
    const rawId = props.match.params.id;
    let decodedId = rawId;
    try {
        decodedId = decodeURIComponent(rawId);
    } catch (e) {}

    for (let i = 0; i < data.length; i++) {
        if (
            data[i].title === rawId ||
            data[i].title === decodedId ||
            (data[i].title_en && (data[i].title_en === rawId || data[i].title_en === decodedId)) ||
            (data[i].title_ru && (data[i].title_ru === rawId || data[i].title_ru === decodedId))
        ) {
            return data[i];
        }
    }
    return null;
};

const Product = (props) => {
    const { t, i18n } = useTranslation();
    const currentLang = (i18n.language || 'hy').slice(0, 2);

    const item = search(props);

    if (!item) {
        return (<div><NotFound /></div>);
    }

    const itemTitle = getProductTitle(item, currentLang);
    const fullTitle = generateFullTitle(item, currentLang);
    const itemContent = getProductContent(item, currentLang);

    let final_images = [];
    let item_image_obj = item['image'];

    if (typeof(item['image']) !== 'object') {
        item_image_obj = [item['image']];
    }

    let firstImagePath = '';
    item_image_obj.forEach((path, idx) => {
        if (idx === 0) firstImagePath = path;
        final_images.push(
            <Image
                className="portfolioitem-img"
                src={process.env.PUBLIC_URL + '/uploads/products/' + path}
                alt={itemTitle}
                key={item['title'] + path}
            />
        );
    });

    const fullImageUrl = firstImagePath ? `/uploads/products/${firstImagePath}` : undefined;

    return (
        <div>
            <SEO
                title={`${itemTitle} - ${t('product_page_suffix')}`}
                description={`${fullTitle}. ${itemContent ? itemContent.slice(0, 160) : t('meta_description')}`}
                image={fullImageUrl}
                type="product"
                productData={{
                    name: fullTitle,
                    description: itemContent || fullTitle
                }}
            />
            <div className="header">
                <div className="fh5co-narrow-content">
                    <h1 style={{ textAlign: 'center', color: 'white', fontSize: '28px' }}>{fullTitle}</h1>
                </div>
            </div>
            <div className="item-container">
                <div className="item-image">
                    {final_images}
                </div>

                <div className="item-desc">
                    {itemContent}
                    <br /><br />
                    {t('product_inquiries_prompt')} <a href="mailto:info@tparan.am">info@tparan.am</a> {t('product_inquiries_suffix')}<br />
                    {t('product_call_prompt')} <a href="tel:+37460446685">060446685</a> {t('product_or')} <a href="tel:+37493407038">093407038</a> {t('product_call_suffix')}
                </div>
            </div>
        </div>
    );
};

export default Product;
